var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"j-center m-b-30"},[(_vm.order.tienda_nube_order_status_id == 1)?_c('b-button',{attrs:{"size":"lg","variant":"primary"},on:{"click":_vm.confirmar}},[_vm._v(" Confirmar Pedido y crear venta ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }